import {
  faCheckCircle,
  faTimesCircle
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import i18n from "../../../constants/i18n";
import getCorePopUpStore from "../../../stores/core/core-popup-store";
import getGiveSubscriptionsStore from "../../../stores/scsr-store/give-subscriptions";
import getUserStore from "../../../stores/user-store";
import ET3Div from "../../et3-div";
import { withLiteObserverAndTheme } from "../../et3-enhanced-render";
import Et3Text from "../../et3-text";
import { SUBSCRIPTION_CONFIRMATION_POPUP_KEYS } from "../../../constants/input-entries-constants";

const GiveSubscriptionConfirmationPopUp = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors, unitX } = theme;
  const userID = getUserStore().userIdInput.get();
  const subscriptionType =
    getCorePopUpStore().confirmationSubscriptionType.get();

  if (!subscriptionType) return <></>;

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      withShadow={false}
      width={1500}
      height={1080}
      fDirection="row"
      alignItems="center"
      justifyContent="center"
      color={colors.all.transparent}
      style={{ position: "fixed", top: 0, zIndex: 5 }}
      onClick={() => {}}
    >
      <ET3Div
        isScrollable={false}
        isExtendable={true}
        fDirection="column"
        justifyContent="space-between"
        alignItems="center"
        withShadow={true}
        width={1000}
        height={250}
        color={colors.all.white}
        style={{ position: "relative", borderRadius: 50, zIndex: 5 }}
        onClick={() => {}}
      >
        <Et3Text
          fontFamily={"BOLD"}
          fontSize={24}
          text={i18n.getWithExtraData(
            SUBSCRIPTION_CONFIRMATION_POPUP_KEYS[subscriptionType],
            getGiveSubscriptionsStore().getExtraDataText(subscriptionType)
          )}
          isSpan={false}
          color={colors.all.black}
          style={{ width: 900 * unitX }}
        />
        <ET3Div
          isScrollable={false}
          isExtendable={true}
          fDirection="row"
          justifyContent="space-between"
          alignItems="center"
          withShadow={false}
          width={500}
          height={100}
          color={colors.all.transparent}
          style={{}}
          onClick={() => {}}
        >
          <FontAwesomeIcon
            className="clickable"
            onClick={async () => {
              await getGiveSubscriptionsStore().makeUser(
                userID,
                subscriptionType
              );
            }}
            icon={faCheckCircle}
            color={colors.all.green}
            style={{}}
            size="3x"
          />
          <FontAwesomeIcon
            className="clickable"
            onClick={() => getCorePopUpStore().closeConfirmationPopUps()}
            icon={faTimesCircle}
            color={colors.all.red}
            style={{}}
            size="3x"
          />
        </ET3Div>
      </ET3Div>
    </ET3Div>
  );
});

export default GiveSubscriptionConfirmationPopUp;
